import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]); // ✅ store unique categories
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(''); // ✅ for dropdown filter

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const response = await axios.get('https://api.deveshmeditechindia.com/api/products?limit=0');
        if (Array.isArray(response.data.products)) {
          setProducts(response.data.products);

          // ✅ Extract unique categories from products
          const uniqueCategories = [
            ...new Set(
              response.data.products
                .map((p) => p.category?.name)
                .filter(Boolean) // remove undefined/null
            ),
          ];
          setCategories(uniqueCategories);

          console.log(response.data.products);
        } else {
          console.error('Expected an array but got:', response.data);
          setProducts([]);
          setError('Failed to load products: invalid data format.');
        }
      } catch (error) {
        console.error('Error fetching products:', error);
        setError('Failed to load products. Please try again later.');
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this product?')) return;
    try {
      await axios.delete(`https://api.deveshmeditechindia.com/api/products/${id}`);
      setProducts(products.filter((product) => product._id !== id));
    } catch (error) {
      console.error('Error deleting product:', error);
      setError('Failed to delete product. Please try again.');
    }
  };

  // ✅ Filter products by search + selected category
  const filteredProducts = products.filter((product) => {
    const matchesSearch =
      product.name?.toLowerCase().includes(search.toLowerCase()) ||
      product.category?.name?.toLowerCase().includes(search.toLowerCase());

    const matchesCategory =
      selectedCategory === '' || product.category?.name === selectedCategory;

    return matchesSearch && matchesCategory;
  });

  return (
    <div className="container mt-4">
      <h2>Products</h2>

      <div className="row mb-3">
        <div className="col-md-6">
          {/* 🔍 Search Bar */}
          <input
            type="text"
            className="form-control"
            placeholder="Search by name or category..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="col-md-6">
          {/* 🏷️ Category Dropdown */}
          <select
            className="form-select"
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            <option value="">All Categories</option>
            {categories.map((cat, idx) => (
              <option key={idx} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </div>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}
      {loading ? (
        <div className="text-center">Loading products...</div>
      ) : filteredProducts.length === 0 ? (
        <div>No products found.</div>
      ) : (
        <ul className="list-group">
          {filteredProducts.map((product) => (
            <li
              key={product._id}
              className="list-group-item d-flex justify-content-between align-items-center"
            >
              <div className="d-flex align-items-center">
                {product.images && product.images.length > 0 ? (
                  <img
                    src={`https://api.deveshmeditechindia.com${product.images[0]}`}
                    className="img-fluid me-3"
                    style={{
                      maxWidth: '200px',
                      maxHeight: '150px',
                      objectFit: 'contain',
                    }}
                    alt={product.name}
                  />
                ) : (
                  <div
                    className="bg-light d-flex align-items-center justify-content-center"
                    style={{ width: '200px', height: '150px' }}
                  >
                    <span className="text-muted">No image</span>
                  </div>
                )}
                <div>
                  <h5 className="mb-1">{product.name}</h5>
                  <p className="mb-1 text-success">
                    ₹{product.price.toFixed(2)}
                  </p>
                  <p className="mb-0 text-muted">
                    Category: {product.category?.name || 'Uncategorized'}
                  </p>
                </div>
              </div>
              <div>
                <Link
                  to={`/edit-product/${product._id}`}
                  className="btn btn-warning btn-sm me-2"
                >
                  Edit
                </Link>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(product._id)}
                >
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ProductList;
